const isTagEmpty = (vNode: any): boolean => {
    if (!vNode.tag) {
        return true;
    }

    const showDirective =
        vNode.data &&
        vNode.data.directives &&
        vNode.data.directives.find((obj) => obj.name === 'show');

    // if the "show" directive is present and currently "false"
    return showDirective && !showDirective.value;
};

const getComponentName = (vNode: any): string => { 
    if (isTagEmpty(vNode)) {
        return '';
    }

    return vNode.componentOptions ? vNode.componentOptions.tag : '';
};

export {
    isTagEmpty,
    getComponentName
};